<script>
import ListItem from './widgets/Accordion/item';

export default {
  name: 'DefaultZizAccordion',
  components: {
    ListItem,
  },
};
</script>

<style lang="scss">
  @import './widgets/Accordion/index';
</style>
